module.exports = __webpack_public_path__ + "static/media/success.81aa7635.svg";